import dayjs from 'dayjs'
import 'dayjs/locale/es'

/**
 * Convierte una fecha en formato 'dd/mm/yyyy' a formato legible en español
 * @param dateString - Fecha en formato 'dd/mm/yyyy'
 * @returns Fecha en formato "17 de diciembre de 2025"
 */
export const formatDateToSpanish = (dateString: string): string => {
  if (!dateString) return ''

  try {
    // Parse the date string in dd/mm/yyyy format
    const date = dayjs(dateString, 'DD/MM/YYYY').locale('es')

    // Check if the date is valid
    if (!date.isValid()) {
      return dateString // Return original if invalid
    }

    // Format to Spanish readable format
    return date.format('D [de] MMMM [de] YYYY')
  } catch (error) {
    console.error('Error formatting date:', error)
    return dateString // Return original if there's an error
  }
}

/**
 * Valida si una fecha es más de 24 horas anterior al momento actual
 * @param dateString - Fecha a validar (puede ser null/undefined)
 * @returns true si la fecha es más de 24 horas anterior, false en caso contrario
 */
export const isDateMoreThan24HoursOld = (dateString: string | null | undefined): boolean => {
  if (!dateString) {
    return true
  }

  try {
    const targetDate = dayjs(dateString)

    if (!targetDate.isValid()) {
      console.warn('Invalid date provided:', dateString)
      return true
    }

    const now = dayjs()

    const hoursDifference = now.diff(targetDate, 'hour')

    return hoursDifference > 24
  } catch (error) {
    console.error('Error validating date:', error)
    return true
  }
}
